import  { useContext, useEffect, useState } from "react";
import { GetAllstageswithstsatus, MarkDocumentRead } from "../../utils/Api/api";
import "../../components/Question/question.scss";
import useGeoLocation from "../../components/geoLocation/GeoLoaction";
import { useNavigate } from "react-router-dom";
import { Context } from "../../contextApi/contextProvider";
import { ShimmerLoaderwhite } from "../../utils/loader/ShimmerLoader";
import SafeIndividual from "../../components/TypesInvestor/SafeIndividual";
import { AccessDOCOBJ } from "../../components/Navbar/Navbar";
import { getPostStatus } from "../../utils/isPostIdPresent";
interface Stage {
  stage_uid: string;
  stage_name: string;
  stage_status: string | "";
  stage_priority: string;
  documents?: {
    post_id: string;
    post_name: string;
    document_status: string;
  }[];
}
const SafeFrom = () => {
  const loaction = useGeoLocation();
  const navigator = useNavigate();
  const { userLoginData, accessDoc, setAccessDoc } = useContext(Context);
  const [dataload, setDataLoad] = useState(true);
  const [currentStatus, setCurrentStatus] = useState({
    name: "",
    status: "",
    uid: "",
  });
  const token = JSON.parse(localStorage.getItem("access_token") as string);

  const getDocumentStatusByPostId = (
    stages: Stage[],
    stage_name: string
  ): string | undefined => {
    return stages
      .find((stage) => stage.stage_name.trim() === stage_name)
      ?.stage_status.trim();
  };

  const readDoc = async () => {
    try {
      const { data } = await MarkDocumentRead({
        ip_address: await userLoginData.ip,
        latitude: loaction.coordinates?.lat ?? "0.0",
        longitude: loaction.coordinates?.lng ?? "0.0",
        post_id: "11482",
      });
    } catch (error) {}
  };

  useEffect(() => {
    if (userLoginData.status == 200 && accessDoc["11482"] !== "de") {
      setDataLoad(true);
      if (accessDoc["11482"] == "ALLOWED") {
        readDoc();
        if (accessDoc?.all_stage_info) {
          const financialProjectionStage = getDocumentStatusByPostId(
            accessDoc?.all_stage_info,
            "Stage 4 - Finalization"
          );

          if (financialProjectionStage) {
            setCurrentStatus({
              name: "",

              uid: "",
              status: financialProjectionStage || "",
            });
          } else {
            setCurrentStatus({
              name: "",

              uid: "",
              status: financialProjectionStage || "",
            });
          }
        }
      } else {
        navigator("/");
      }
      setDataLoad(false);
    } else if (userLoginData.status == 404) {
      navigator("/");
    } else if (token === "" || token === null || token === undefined) {
      navigator("/");
    }

    window.scrollTo(0, 0);
    document.title = "TICCA | SAFE Agreement";
  }, [userLoginData.status, accessDoc]);

  const getStageStatus = (
    stages: Stage[],
    stage_name: string
  ): string | undefined => {
    return stages.find((stage) => stage.stage_name === stage_name)
      ?.stage_status;
  };

  const getTalk = async () => {
    setDataLoad(true);
    try {
      const response = await GetAllstageswithstsatus({
        ip_address: await userLoginData.ip,
        latitude: await loaction.coordinates.lat,
        longitude: await loaction.coordinates.lng,
      });

      if (response?.data) {
        const financialProjectionStage = await getStageStatus(
          response?.data?.all_stage_info,
          "Stage 4 - Finalization"
        );
        setAccessDoc(response?.data);
        const updatedAccessDOCOBJ: AccessDOCOBJ = { ...accessDoc };
        Object.keys(updatedAccessDOCOBJ).forEach((key) => {
          const status = getPostStatus(key, response?.data?.all_stage_info);
          updatedAccessDOCOBJ[key] = status;
        });
        setAccessDoc({
          ...updatedAccessDOCOBJ,
          all_stage_info: response?.data?.all_stage_info,
        });

        if (financialProjectionStage) {
          setCurrentStatus({
            name: "",

            uid: "",
            status: financialProjectionStage || "",
          });
          // cmsContent()
        } else {
          setCurrentStatus({
            name: "",
            uid: "",
            status: financialProjectionStage || "",
          });
          // cmsContent()
        }
      }
      setDataLoad(false);
    } catch (error) {}
  };

  return (
    <>
      {currentStatus?.status == "PENDING" ? (
        <>
          {" "}
          <div className="valuable-question-main-dev">
            <div className="valuable-question-dev">
              <p className="valuable-question-title">
                Your request has been sent and we will respond as soon as
                possible
              </p>
            </div>
          </div>
        </>
      ) : currentStatus?.status == "ALLOWED" ? (
        <>
          {" "}
          <div className="valuable-question-main-dev">
            <div className="valuable-question-dev">
              <p className="valuable-question-title">
                Your request is already accepted
              </p>
            </div>
          </div>
        </>
      ) : currentStatus?.status == "DENIED" ? (
        <>
          {" "}
          <div className="valuable-question-main-dev">
            <div className="valuable-question-dev">
              <p className="valuable-question-title">Your request is denied</p>
            </div>
          </div>
        </>
      ) : dataload == true ? (
        <>
          <div className="valuable-question-main-dev">
            <ShimmerLoaderwhite />
          </div>
        </>
      ) : (
        <>
          <SafeIndividual
            userName={userLoginData}
            setCurrentStatus={setCurrentStatus}
            getTalk={getTalk}
          />
        </>
      )}
    </>
  );
};

export default SafeFrom;
